module.exports = __webpack_public_path__ + "static/media/welcometitle.614acce3.png";